module.exports = __webpack_public_path__ + "static/emmalundberg-6388a40e875788f6b4bffa37a19a39bf.jpg";